import { forwardRef } from "react";
import { A11yBase } from "../a11y-base";
import { useKeyboardA11y } from "../hooks";
import { A11yRootProps } from "./types";

export const A11yRoot = forwardRef<HTMLElement, A11yRootProps>(
  ({ onArrowDown, onArrowUp, onEnter, ...rest }, ref) => {
    const { handleKeyDown } = useKeyboardA11y({
      ArrowDown: onArrowDown,
      ArrowUp: onArrowUp,
      Enter: onEnter,
    });

    return <A11yBase {...rest} onKeyDown={handleKeyDown} ref={ref} />;
  }
);

A11yRoot.displayName = "A11yRoot";
